import { useEffect, useRef, useState } from "react";
import { Button, Form } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import { useDispatch, useSelector } from "react-redux";
import {
  closeSelectAddressModel,
  openAddAnotherAddress,
  openAddressFromMap,
} from "../../store/slices/modalSlice";
import { useLoadScript } from "@react-google-maps/api";
import axiosInstance from "../../api/axiosInstance";
const baseUrl = import.meta.env.VITE_API_URL;
const googleMapsApiKey = import.meta.env.VITE_Google_Maps_Api_Key;

interface Address {
  RecordId: number;
  userName: string;
  session: string | null;
  address_type: string | null;
  address_detail: string | null;
  address: string | null;
  status: string | null;
  createdon: string | null;
  modifiedon: string;
  addresNickname: string;
  streetName: string;
  building: string;
  floor: string;
  flatNo: string;
  landmark: string;
  primaryAddress: number;
}

const libraries: "places"[] = ["places"];

const SelectAddressModel = () => {
  const dispatch = useDispatch();
  const [billingData, setBillingData] = useState<Address[]>([]);
  const [selectedOption, setSelectedOption] = useState<number | null>(null);
  const [toggle, setToggle] = useState<any>();
  const toggleMenuRef = useRef<HTMLDivElement | null>(null);

  const showSelectAddress = useSelector(
    (state: { modal: { selectAddressModel: boolean } }) =>
      state.modal.selectAddressModel
  );


  const handleClick = (id: number) => {
    setSelectedOption(id);
  };

  useEffect(() => {
    const localStorageData = sessionStorage.getItem("userName");
    const storedAddressData = sessionStorage.getItem("address");
    if (storedAddressData && storedAddressData !== "null" && storedAddressData !== "undefined") {
      const addressData = JSON.parse(storedAddressData);
      setSelectedOption(addressData.RecordId);
    }
    if (localStorageData) {
    }

    fetchAddressFromApi();
  }, []);

  const closeSelectAddress = () => {
    dispatch(closeSelectAddressModel());
  };

  const openSelectAddress = () => {
    dispatch(closeSelectAddressModel());
    dispatch(openAddAnotherAddress());
  };

  const handleSelectedAddress = () => {

    billingData.forEach((item) => {
      if (item.RecordId === selectedOption) {
        sessionStorage.setItem("address", JSON.stringify(item));
        sessionStorage.setItem("billingRecordID", item.RecordId.toString());
        dispatch(closeSelectAddressModel());
      }
    });
  };

  const fetchAddressFromApi = async () => {
    const login_info = localStorage.getItem("Login_info");

    if (!login_info) return;

    try {
      if (!baseUrl) {
        throw new Error("Base URL is not defined in the environment variables");
      }
      const response = await axiosInstance.post(
        `/api/user/userAddressShow`,
        {}
      );
      if (response) {
        setBillingData(response.data.mainAddressList.billingAddress);
        handleClick(response.data.mainAddressList.billingAddress[0].RecordId);
      }
    } catch (error) {
      sessionStorage.removeItem("billing");
      console.error("Error fetching order data:", error);
    }
  };

  const handleDelete = async (val: string, id: number) => {
    const login_info = localStorage.getItem("Login_info");

    if (!login_info) return;

    try {
      if (!baseUrl) {
        throw new Error("Base URL is not defined in the environment variables");
      }

      const response = await axiosInstance.delete(
        `/api/user/userAddressDelete/?id=${id}`,
        {}
      );

      if (response && val === "Billing") {
        setBillingData((prev) => prev.filter((add) => add.RecordId !== id));
        sessionStorage.removeItem("address");
      }
    } catch (error) {
    }
  };

  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: googleMapsApiKey,
    libraries,
  });

  const handleOpenEditModal = (val: string, id: number) => {

    const filteredData = billingData.filter((item) => item.RecordId === id);

    if (filteredData.length > 0) {
      localStorage.setItem("filteredData", JSON.stringify(filteredData[0]));
    }

    if (val === "Edit") {
      sessionStorage.setItem("mode", "Edit");
      dispatch(openAddressFromMap());
      dispatch(closeSelectAddressModel());
    }
  };

  useEffect(() => {
  const handleClickOutside = (event: MouseEvent) => {
    if (
      toggleMenuRef.current &&
      !toggleMenuRef.current.contains(event.target as Node)
    ) {
      setToggle(null);
    }
  };

  document.addEventListener("mousedown", handleClickOutside);
  return () => {
    document.removeEventListener("mousedown", handleClickOutside);
  };
}, []);

  if (loadError) {
    return <div className="text-red-500">Error loading maps</div>;
  }

  if (!isLoaded) {
    return (
      <div className="flex items-center justify-center h-screen">
        {/* <MapPin className="w-8 h-8 text-blue-500 animate-bounce" /> */}
      </div>
    );
  }

  return (
    <Modal
      show={showSelectAddress}
      onHide={closeSelectAddress}
      centered
      scrollable
      className="mb-fix slide-from-bottom"
      backdrop="static"
    >
      <Modal.Header closeButton>
        {/* <Modal.Title className="h4 text-dark">Saved addresses</Modal.Title> */}
      </Modal.Header>

      <Modal.Body className="modal-dialog-scrollable rounded-top">
        <p className="font-17 ff-semibold text-black">My Addresses</p>
        <div
          className="address-container d-flex flex-wrap align-items-center gap-2 pt-2 pb-2 mb-3   bg-3 p-2 rounded-2"
          onClick={openSelectAddress}
        >
          <div className="address-icon-container">
            <div className="address-icon">
              <img
                src="https://goodhand.b-cdn.net/Assets/cart/cart-flow/map-mark.svg"
                alt=""
              />
            </div>
          </div>
          <div className="address-text-container">
            <p className="address-text mb-0 font-14 ff-semibold text-main cursor-pointer">
              Add another address
            </p>
          </div>
        </div>
        {billingData.length > 0 ? (
          <>
            {billingData.map((val, index) => (
              <div
                className={`d-flex align-items-start justify-content-start gap-3 p-2 ${
                  index !== billingData.length - 1 ? "border-bottom" : ""
                }`}
                key={val.RecordId}
              >
                <Form.Check
                  type="radio"
                  id={`option-${val.RecordId}`}
                  name="address"
                  className="me-2"
                  onClick={() => handleClick(val.RecordId)}
                  checked={selectedOption === val.RecordId}
                />
                <div
                  className="cursor-pointer"
                  onClick={(e) => {
                    e.stopPropagation(); // 👈 prevent bubbling
                    handleClick(val.RecordId);
                  }}
                >
                  <p className="font-16 fw-semibold text-black mb-0">
                    {val.addresNickname}
                  </p>
                  <p className="font-12 fw-medium">
                    {val.flatNo} , {val.streetName}
                  </p>
                </div>
                <div className="position-relative ms-auto" onClick={() =>
                      setToggle((prev: any) =>
                        prev === val.RecordId ? null : val.RecordId
                      )
                    }>
                  <div
                    className="bg-transparent border-0 p-0 ps-4"
                    
                  >
                    <svg
                      className="cursor-pointer"
                      width="4"
                      height="20"
                      viewBox="0 0 4 18"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      {[1, 9, 16].map((cy, index) => (
                        <circle
                          key={index}
                          cx="2"
                          cy={cy}
                          r="1"
                          stroke="#979797"
                          strokeWidth="2"
                        />
                      ))}
                    </svg>
                  </div>

                  {toggle === val.RecordId && (
                    <div
                    ref={toggleMenuRef}
                      className="position-absolute end-0 mt-2 rounded-3 shadow-sm p-3 bg-white"
                      style={{
                        background: "#fff",
                        width: "180px",
                        zIndex: 10,
                        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
                      }}
                    >
                      <div
                        className="d-flex align-items-center gap-2 mb-2 p-3 bg-2 rounded-3 cursor-pointer"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleOpenEditModal("Edit", val.RecordId);
                        }}
                      >
                        <svg
                          width="15"
                          height="15"
                          viewBox="0 0 15 15"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M1 14H4.39239L13.2974 5.09498C13.5202 4.87223 13.6969 4.60779 13.8174 4.31676C13.938 4.02572 14 3.71379 14 3.39878C14 3.08377 13.938 2.77184 13.8174 2.48081C13.6969 2.18977 13.5202 1.92533 13.2974 1.70259C13.0747 1.47984 12.8102 1.30315 12.5192 1.1826C12.2282 1.06205 11.9162 1 11.6012 1C11.2862 1 10.9743 1.06205 10.6832 1.1826C10.3922 1.30315 10.1278 1.47984 9.90502 1.70259L1 10.6076V14Z"
                            stroke="black"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>

                        <span className="ff-semibold">Edit</span>
                      </div>
                      <div
                        className="d-flex align-items-center gap-2 p-3 bg-2 rounded-3 cursor-pointer"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleDelete("Billing", val.RecordId);
                        }}
                      >
                        <svg
                          width="15"
                          height="16"
                          viewBox="0 0 15 16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M1 4.10938H13.4444"
                            stroke="#DD4040"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M5.66797 7.22266V11.8893"
                            stroke="#DD4040"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M8.77734 7.22266V11.8893"
                            stroke="#DD4040"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M1.77734 4.10938L2.55512 13.4427C2.55512 13.8553 2.71901 14.2509 3.01073 14.5427C3.30246 14.8344 3.69812 14.9983 4.11068 14.9983H10.3329C10.7455 14.9983 11.1411 14.8344 11.4328 14.5427C11.7246 14.2509 11.8885 13.8553 11.8885 13.4427L12.6662 4.10938"
                            stroke="#DD4040"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M4.89062 4.11111V1.77778C4.89062 1.5715 4.97257 1.37367 5.11843 1.22781C5.26429 1.08194 5.46212 1 5.6684 1H8.77951C8.98579 1 9.18362 1.08194 9.32949 1.22781C9.47535 1.37367 9.55729 1.5715 9.55729 1.77778V4.11111"
                            stroke="#DD4040"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>

                        <span className="text-danger ff-semibold">Delete</span>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </>
        ) : (
          <>
            <div className="error-location text-center">
              <svg
                width="128"
                height="96"
                viewBox="0 0 72 72"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M10 20h20v44H10V20z" fill="#FFD47F"></path>
                <path d="M22 8h20L30 20H10L22 8z" fill="#9E4D10"></path>
                <path d="M30 20L42 8l12 12v44H30V20z" fill="#FFE0A3"></path>
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M18 28h-4v10h4V28zm0 14h-4v10h4V42zm4-14h4v10h-4V28zm4 14h-4v10h4V42z"
                  fill="#fff"
                ></path>
                <path
                  d="M54.411 28.006a13.998 13.998 0 00-8.222 2.39 14.047 14.047 0 00-5.302 6.738 14.081 14.081 0 00-.405 8.57c.76 2.83 2.384 5.35 4.644 7.21a30.672 30.672 0 016.19 6.622 23.79 23.79 0 012.182 4.141.543.543 0 00.79.235.542.542 0 00.2-.235 23.156 23.156 0 012.244-4.079 29.861 29.861 0 016.082-6.576 13.954 13.954 0 003.873-4.951 13.985 13.985 0 001.311-6.154 14.625 14.625 0 00-4.145-9.554 14.563 14.563 0 00-9.442-4.357z"
                  fill="#DC2804"
                ></path>
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M54 40.586l-4.293-4.293-1.414 1.414L52.586 42l-4.294 4.294 1.415 1.414L54 43.414l4.293 4.293 1.414-1.414L55.414 42l4.293-4.293-1.414-1.414L54 40.586z"
                  fill="#fff"
                ></path>
              </svg>

              <p className="my-3 font-16 ff-semibold">No Address Found</p>
            </div>
          </>
        )}
      </Modal.Body>
      
      {billingData.length > 0 && (
      <Modal.Footer className="shadow-none border-top">
        <Button
          variant="primary"
          onClick={handleSelectedAddress}
          className="w-100 fw-semibold py-3"
        >
          Proceed
        </Button>
      </Modal.Footer>
      )}
    </Modal>
  );
};

export default SelectAddressModel;
